var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile-stats white-bg"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "status"
  }, [_vm._m(0), _vm._v(" "), (_vm.customerId) ? _c('div', {
    staticClass: "form-group"
  }, [_c('p', [_vm._v("Your Account Number")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "input-account",
      "readonly": ""
    },
    domProps: {
      "value": _vm.customerId
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', [_vm._v("Your private API key")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "readonly": "",
      "type": _vm.tokenType
    },
    domProps: {
      "value": _vm.token
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleTokenVisibility
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.refreshToken
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })])])])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet-heading"
  }, [_c('h4', {
    staticClass: "portlet-title text-dark text-uppercase"
  }, [_vm._v("\n          API\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "portlet-widgets"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "data-toggle": "reload"
    }
  }, [_c('i', {
    staticClass: "ion-refresh"
  })]), _vm._v(" "), _c('span', {
    staticClass: "divider"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion1",
      "href": "#portlet2"
    }
  }, [_c('i', {
    staticClass: "ion-minus-round"
  })]), _vm._v(" "), _c('span', {
    staticClass: "divider"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#",
      "data-toggle": "remove"
    }
  }, [_c('i', {
    staticClass: "ion-close-round"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-159ea9c0","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/dashboard/api-key.vue
// module id = 476
// module chunks = 0